import * as React from 'react'
import Typography from '@material-ui/core/Typography'
import { IControlProps } from './types'

export const UnsupportedControl = (_props: IControlProps) => (
  <Typography>This field type is not yet supported</Typography>
)
